// extracted by mini-css-extract-plugin
export const splitSection = "splitview-module--splitSection--h_THW";
export const splitWrapper = "splitview-module--splitWrapper--2aNuS";
export const splitWrapperReverse = "splitview-module--splitWrapperReverse--2u-dH";
export const imageSplit = "splitview-module--imageSplit--kuET_";
export const contentSplit = "splitview-module--contentSplit--2g7No";
export const contentSplitGrey = "splitview-module--contentSplitGrey--2ZuwZ";